var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpowerment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 34.6875V9.375C5.625 7.88316 6.21763 6.45242 7.27252 5.39752C8.32742 4.34263 9.75816 3.75 11.25 3.75H37.5C37.9973 3.75 38.4742 3.94754 38.8258 4.29917C39.1775 4.65081 39.375 5.12772 39.375 5.625V39.375C39.375 39.8723 39.1775 40.3492 38.8258 40.7008C38.4742 41.0525 37.9973 41.25 37.5 41.25H12.1875C10.447 41.25 8.77782 40.5586 7.54711 39.3279C6.3164 38.0972 5.625 36.428 5.625 34.6875ZM35.625 37.5V31.875H12.1875C11.4416 31.875 10.7262 32.1713 10.1988 32.6988C9.67132 33.2262 9.375 33.9416 9.375 34.6875C9.375 35.4334 9.67132 36.1488 10.1988 36.6762C10.7262 37.2037 11.4416 37.5 12.1875 37.5H35.625ZM9.375 28.7569C10.2538 28.3396 11.2147 28.1237 12.1875 28.125H35.625V7.5H11.25C10.7527 7.5 10.2758 7.69754 9.92418 8.04918C9.57254 8.40081 9.375 8.87772 9.375 9.375V28.7569Z",
    fill: "#203468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerment);
export default __webpack_public_path__ + "static/media/Empowerment.7e5684732f13334e8832c9d54dc7afb0.svg";
export { ForwardRef as ReactComponent };